import dayjs from "dayjs";
import { useState } from "react";
import { formatCurrency } from "../../../utils/formatCurrency";
import { uploadFile } from "../../../FirebaseConfig.ts";
import useUpdateDoc from "../../../hooks/useUpdateDoc";
import useInsertDoc from "../../../hooks/useInsertDoc.js";

function Abono({
  abonoModal,
  data,
  setAbonoModal,
  deuda,
  cuotaFija,
  investor,
  date,
}) {
  const [abono, setAbono] = useState();
  const [recalculo, setRecalculo] = useState("mantener");
  const [detalle, setDetalle] = useState("");
  const [newMonth, setNewMonth] = useState("");
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [file, setFile] = useState(null);
  const { handleUpdate } = useUpdateDoc();
  const { handleInsert } = useInsertDoc();

  const abonos = Array.isArray(data?.abono) ? data.abono : [];
  const ultimoAbono = abonos[abonos.length - 1];

  const currentDebt = deuda;

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleAgregarAbono = async () => {
    setIsProcessingPayment(true);

    try {
      const nuevaDeuda = currentDebt - abono;
      let fileUrl;

      if (file) {
        const filePath = `credit/${data.numberCredit}/abono/${Date.now()}`;
        fileUrl = await uploadFile(file, filePath);
      }

      let dataUpdate = {};

      if (recalculo === "recalcular") {
        const nuevoSaldo = Number(currentDebt) - Number(abono);
        dataUpdate = { ammount: nuevoSaldo };
      } else if (recalculo === "mantener") {
        const tasaAnual = data.tasa;
        const tasaMensual = Math.pow(1 + tasaAnual / 100, 1 / 12) - 1;

        const nuevoSaldo = Number(currentDebt) - Number(abono);
        const cuotaFija1 = Number(cuotaFija);

        const n =
          -Math.log(1 - tasaMensual * (nuevoSaldo / cuotaFija1)) /
          Math.log(1 + tasaMensual);

        const nuevasCuotas = Math.ceil(n);

        dataUpdate = {
          ammount: nuevoSaldo,
          remainingMonths: nuevasCuotas,
          type: recalculo,
        };
      } else {
        const nuevoSaldo = Number(currentDebt) - Number(abono);
        const cuotaFija1 = Number(cuotaFija);

        const nuevasCuotas = newMonth;

        dataUpdate = {
          ammount: nuevoSaldo,
          remainingMonths: nuevasCuotas,
          type: recalculo,
        };
      }

      handleUpdate("investor", investor.uuid, {
        currentAmmount:
          Number(abono) +
          (investor.currentAmmount ? Number(investor.currentAmmount) : 0),
      });

      const movementData = {
        investorId: investor.uuid,
        investorName: investor.name,
        type: "ingreso_abono",
        amount: Number(abono),
        detail: "",
        creditId: data?.uuid,
        creditData: {
          name: "",
          lastName: "",
          identity: "",
          numberCredit: "",
        },
        date: `${date}`,
        status: "completado",
        description: `Abono recibido de ${data.name} ${
          data.lastName
        } por valor de ${formatCurrency(Number(abono))}`,
      };

      const resM = await handleInsert("investorMovements", {
        ...movementData,
      });

      const resA = await handleInsert("investorAbonos", {
        ...movementData,
        idMovement: resM.id,
      });

      await handleUpdate("investorAbonos", resA.id, {
        uuid: resA.id,
      });

      handleUpdate("requests", data.uuid, {
        abono: [
          ...(Array.isArray(data?.abono) ? data.abono : []),
          {
            amount: Number(abono),
            date: date,
            detail: detalle?.trim() || "",
            comprobante: fileUrl || null,
            type: recalculo,
            planVersion: (data?.abono?.length ?? 0) + 2,
            startInstallment: (data.payments?.length ?? 0) + 1,
            // idMovement: resM.id,
            idAbono: resA.id,
            ...dataUpdate,
          },
        ],
      });

      setPaymentSuccess(true);
      setAbono();
      setDetalle("");
      setFile(null);
    } catch (error) {
      console.error("Error al registrar el abono:", error);
    } finally {
      setIsProcessingPayment(false);
    }
  };

  return (
    <>
      {abonoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 max-h-[600px] overflow-y-scroll">
            <div className="space-y-4">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-semibold text-gray-900">
                  Agregar Abono
                </h3>
                <button
                  onClick={() => setAbonoModal(false)}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                  disabled={isProcessingPayment}
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              {/* Datos actuales */}
              <div className="bg-gray-50 rounded-lg p-4 space-y-3">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Cliente:</span>
                  <span className="font-medium">
                    {data.name} {data.lastName}
                  </span>
                </div>

                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Deuda pendiente:</span>
                  <span className="font-medium text-red-600">
                    {formatCurrency(currentDebt)}
                  </span>
                </div>
              </div>

              {/* Valor del abono */}
              <div className="space-y-1">
                <label
                  htmlFor="valorAbono"
                  className="text-sm font-medium text-gray-700"
                >
                  Valor del abono
                </label>
                <input
                  id="valorAbono"
                  type="number"
                  placeholder="Ej: 500000"
                  value={abono}
                  onChange={(e) => setAbono(Number(e.target.value))}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                />
              </div>

              {/* Opciones de recalculo */}
              <div className="space-y-2">
                <span className="text-sm font-medium text-gray-700">
                  ¿Qué deseas hacer?
                </span>
                <div className="flex flex-col space-y-2">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="recalculo"
                      value="mantener"
                      checked={recalculo === "mantener"}
                      onChange={(e) => setRecalculo(e.target.value)}
                    />
                    <span className="text-sm text-gray-700">
                      Mantener la cuota mensual fija
                    </span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="recalculo"
                      value="recalcular"
                      checked={recalculo === "recalcular"}
                      onChange={(e) => setRecalculo(e.target.value)}
                    />
                    <span className="text-sm text-gray-700">
                      Recalcular una nueva cuota con base en los meses restantes
                    </span>
                  </label>

                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="recalculo_plazo"
                      value="recalculo_plazo"
                      checked={recalculo === "recalculo_plazo"}
                      onChange={(e) => setRecalculo(e.target.value)}
                    />
                    <span className="text-sm text-gray-700">
                      Recalcular en base a nuevo plazo
                    </span>
                  </label>
                </div>
              </div>
              {recalculo === "recalculo_plazo" && (
                <div className="space-y-1">
                  <label
                    htmlFor="detalle"
                    className="text-sm font-medium text-gray-700"
                  >
                    Número de meses
                  </label>
                  <input
                    type="number"
                    value={newMonth}
                    onChange={(e) => setNewMonth(e.target.value)}
                    className="w-full px-4 py-2 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  />
                </div>
              )}

              {/* Detalle del abono */}
              <div className="space-y-1">
                <label
                  htmlFor="detalle"
                  className="text-sm font-medium text-gray-700"
                >
                  Detalle del abono
                </label>
                <textarea
                  id="detalle"
                  rows={3}
                  placeholder="Ej: Abono realizado por el cliente en efectivo..."
                  value={detalle}
                  onChange={(e) => setDetalle(e.target.value)}
                  className="w-full px-4 py-2 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                />
              </div>

              {/* Archivo adjunto */}
              <div className="space-y-1">
                <label
                  htmlFor="file"
                  className="text-sm font-medium text-gray-700"
                >
                  Adjuntar comprobante (opcional)
                </label>
                <input
                  id="file"
                  type="file"
                  onChange={handleFileChange}
                  className="w-full text-sm text-gray-700 border border-gray-300 rounded-xl p-2 cursor-pointer focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {paymentSuccess ? (
                <div className="text-center space-y-4">
                  <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Abono registrado exitosamente
                    </h3>
                  </div>
                  {/* Arreglar que pueda seleccionar varios empleados */}
                  <button
                    onClick={() => {
                      setAbonoModal(false);
                      setPaymentSuccess(false);
                    }}
                    className="w-full px-4 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg font-medium hover:from-green-600 hover:to-green-700 transition-all"
                  >
                    Cerrar
                  </button>
                </div>
              ) : (
                ""
              )}
              {/* Botones */}
              <div className="flex gap-3 pt-4">
                <button
                  onClick={() => setAbonoModal(false)}
                  disabled={isProcessingPayment}
                  className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors disabled:opacity-50"
                >
                  Cancelar
                </button>
                <button
                  onClick={handleAgregarAbono}
                  disabled={isProcessingPayment || !abono}
                  className="flex-1 px-4 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg font-medium hover:from-green-600 hover:to-green-700 transition-all disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  {isProcessingPayment ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                      <span>Procesando...</span>
                    </>
                  ) : (
                    <>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span>Confirmar Abono</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Abono;
